<div class="table-container">
    <app-table [data]="tools"
               [treeMode]="tree"
               [rowExpand]="rowExpand"
               [config]="tableConfig"
               [groupableColumns]="groupableColumns"
               [hasPagination]="false"
               [isLoading]="isLoading"
               [isMaterial]="isMaterial"
               [hasTitle]="hasTitle"
               [showFilters]="showFilters"
               title="{{'atom.tool-requests-lines.process.title' | translate}}"
               (pageChange)="onPageChange($event)"
               (sortChange)="onSortChange($event)"
               (filterChange)="onFilterChange($event)">
        <app-table-column header="{{'atom.tool-requests-lines.process.table.columns.name' | translate}}"
                          [showTree]="true"
                          [filter]="filter"
                          [sortable]="false"
                          filterPlaceholder="{{'atom.tool-requests-lines.process.table.filters.byName' | translate}}"
                          field="name">
        </app-table-column>
        <app-table-column header="{{'atom.tool-requests-lines.process.table.columns.uid' | translate}}"
                          [filter]="filter"
                          [sortable]="false"
                          filterPlaceholder="{{'atom.tool-requests-lines.process.table.filters.byUid' | translate}}"
                          field="toolUidAndSetId">
        </app-table-column>

        <app-table-column header="{{'atom.tool-requests-lines.process.table.columns.status' | translate}}"
                          [sortable]="false"
                          field="status">
            <ng-template #filter
                         let-column="column"
                         let-table="table">
                <app-dropdown [(ngModel)]="column.filterValue"
                              [items]="filterStatusList"
                              valueField="value"
                              displayField="name"
                              emptyText="Status"
                              (selectItem)="table.onFilterChange(column)"></app-dropdown>
            </ng-template>
            <ng-template #body
                         let-record="record">
                <span>{{ record.status | translate }}</span>
            </ng-template>
        </app-table-column>
        <app-table-column header="{{'atom.tool-requests-lines.process.table.columns.stance' | translate}}"
                          [sortable]="false"
                          field="stance">
        </app-table-column>
        <app-table-column>
            <ng-template #body
                         let-tool="record">
                <app-tooltip *ngIf="tool.isAlreadyReservedForLine"
                             tooltipPosition="top"
                             type="warning"
                             [record]="'atom.tool-requests-lines.process.warnings.isAlreadyReservedForLine' | translate">
                </app-tooltip>
                <app-tooltip *ngIf="tool.shouldBeReplaced"
                             tooltipPosition="top"
                             type="important"
                             [record]="'atom.tool-requests-lines.process.warnings.shouldBeReplaced' | translate"
                             (click)="onToolReplace(tool)">
                </app-tooltip>
                <app-tooltip *ngIf="tool.lineSwitch"
                             tooltipPosition="top"
                             type="switch"
                             [record]="'atom.tool-requests-lines.process.warnings.lineSwitch' | translate">
                </app-tooltip>
            </ng-template>
        </app-table-column>
    </app-table>
</div>


